import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage'; // Importing getStorage from firebase storage module

const firebaseConfig = {
  apiKey: "AIzaSyAwHHrifLfVLpX9Dwzi6tDDWp9EmOwc9i8",
  authDomain: "erps-cdea6.firebaseapp.com",
  projectId: "erps-cdea6",
  storageBucket: "erps-cdea6.firebasestorage.app",
  messagingSenderId: "380664741325",
  appId: "1:380664741325:web:b05e4248c714578a50d884"
}

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app); // Initializing Firebase Storage with the app instance

export { auth, db, storage }; // Exporting auth, db, and storage
